import React from 'react';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FiClipboard, FiPlusCircle } from 'react-icons/fi';
import { RiDashboardLine, RiMenu2Fill } from 'react-icons/ri';
import { Link, useLocation } from 'react-router-dom';

interface NavItem {
  to: string;
  label: string;
  icon: IconType;
  isActive: (pathname: string) => boolean;
}

const NAV_ITEMS: NavItem[] = [
  {
    to: '/menu',
    label: 'Menu',
    icon: RiMenu2Fill,
    isActive: () => false,
  },
  {
    to: '/quality-control',
    label: 'Dashboard',
    icon: RiDashboardLine,
    isActive: pathname => pathname === '/quality-control',
  },
  {
    to: '/quality-control/new',
    label: 'Registrar NC',
    icon: FiPlusCircle,
    isActive: pathname => pathname === '/quality-control/new',
  },
  {
    // O detalhe de uma NC (/quality-control/:id) também acende esta aba.
    to: '/quality-control/non-conformities',
    label: 'Não Conformidades',
    icon: FiClipboard,
    isActive: pathname =>
      pathname.startsWith('/quality-control/') &&
      pathname !== '/quality-control/new',
  },
];

/**
 * Abas do módulo para telas pequenas — mesmos destinos da SidebarNavQuality.
 * Abaixo de `lg` a Sidebar vira Drawer (escondida atrás do ☰); esta barra
 * deixa a navegação sempre visível. A partir de `lg` some e vale a Sidebar.
 */
export const MobileNav: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <Flex
      as="nav"
      display={{ base: 'flex', lg: 'none' }}
      bg="gray.800"
      borderWidth="1px"
      borderColor="gray.700"
      borderRadius="lg"
      p="1"
      mb="4"
      gridGap="1"
    >
      {NAV_ITEMS.map(item => {
        const active = item.isActive(pathname);
        return (
          <Flex
            key={item.to}
            as={Link}
            to={item.to}
            flex="1"
            direction="column"
            align="center"
            justify="center"
            gridGap="1"
            py="2"
            px="1"
            borderRadius="md"
            bg={active ? 'blue.500' : 'transparent'}
            color={active ? 'white' : 'gray.400'}
            _hover={{ bg: active ? 'blue.500' : 'gray.700' }}
            aria-current={active ? 'page' : undefined}
          >
            <Icon as={item.icon} fontSize="20" />
            <Text
              fontSize="xs"
              fontWeight="600"
              textAlign="center"
              lineHeight="1.2"
            >
              {item.label}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};
